module.exports = __webpack_public_path__ + "media/images/monthly15-d2a3037b2fd41355c12617e4b79e1c49.jpg";